import { authorizationMiddleware } from './authorization'

export default defineNuxtRouteMiddleware(async to => {
	const isPanel = to.path.includes('/panel')

	if (!isPanel) return

	return await authorizationMiddleware()
})
